import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-go-to-main-component.tsx
/**
* icon.24.go.to.main.component
*
* Keywords: go to, pop out, external
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNSA2YS41LjUgMCAwIDAgMCAxaDIuNzkzbC00LjY0NiA0LjY0NmEuNS41IDAgMCAwIC43MDcuNzA4TDE3IDcuNzA3VjEwLjVhLjUuNSAwIDAgMCAxIDBWN2ExIDEgMCAwIDAtMS0xem0tMi42NDYgMS4xNDZhLjUuNSAwIDAgMSAwIC43MDhMNi43MDcgMTIgMTIgMTcuMjkzbDQuMTQ3LTQuMTQ3YS41LjUgMCAwIDEgLjcwNy43MDhMMTIuNzA3IDE4YTEgMSAwIDAgMS0xLjQxNCAwTDYgMTIuNzA3YTEgMSAwIDAgMSAwLTEuNDE0bDQuMTQ3LTQuMTQ3YS41LjUgMCAwIDEgLjcwNyAwIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-3653
*/
const Icon24GoToMainComponent = memo(function Icon24GoToMainComponent(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M13.5 6a.5.5 0 0 0 0 1h2.793l-4.646 4.646a.5.5 0 0 0 .707.708L17 7.707V10.5a.5.5 0 0 0 1 0V7a1 1 0 0 0-1-1zm-2.646 1.146a.5.5 0 0 1 0 .708L6.707 12 12 17.293l4.147-4.147a.5.5 0 0 1 .707.708L12.707 18a1 1 0 0 1-1.414 0L6 12.707a1 1 0 0 1 0-1.414l4.147-4.147a.5.5 0 0 1 .707 0",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24GoToMainComponent };

//# sourceMappingURL=icon-24-go-to-main-component.js.map